import { render, staticRenderFns } from "./PermissionsChangeModal.vue?vue&type=template&id=d8d718c2&scoped=true"
import script from "./PermissionsChangeModal.vue?vue&type=script&lang=js"
export * from "./PermissionsChangeModal.vue?vue&type=script&lang=js"
import style0 from "./PermissionsChangeModal.vue?vue&type=style&index=0&id=d8d718c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d718c2",
  null
  
)

export default component.exports